import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Pricing from '../../../Utilitis/Pricing/Pricing'
import Section from '../../../Utilitis/Section'
import TitleSection from '../../../Utilitis/TitleSection'

export default function OurPricing() {
    return (
        <Section bg="#f3f7f9">
            <Container>
                <TitleSection text="Our Pricing"  center/>
                <Row>
                    <Col lg={4} md={4} sm={12} xs={12}> <Pricing color="#4382FF" /> </Col>
                    <Col lg={4} md={4} sm={12} xs={12}> <Pricing color="#554DA7" active /> </Col>
                    <Col lg={4} md={4} sm={12} xs={12}> <Pricing color="#F94FA4" /> </Col>
                </Row>
            </Container>
        </Section>
    )
}
